import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { onEnterIndexRoute } from 'router/loaders/index';
import { signupSearchParams } from 'router/search/signup';
import { headSignupSubRoute } from 'router/utils';

import { WelcomeFirstLoadTracker } from 'pages/Signup/components/WelcomeFirstLoadTracker';
import { WelcomePage } from 'pages/Signup/Step/steps/WelcomePage';
import { LeadProvider } from 'providers/LeadProvider';
import { StepsProvider } from 'providers/StepsProvider';
import { getCouponEligibilityQueryOptions } from 'services/partnersSelfSignup';

export const Route = createFileRoute('/')({
  component: () => (
    <LeadProvider>
      <StepsProvider>
        <WelcomeFirstLoadTracker />

        <WelcomePage />
      </StepsProvider>
    </LeadProvider>
  ),
  validateSearch: zodValidator(signupSearchParams),
  head: headSignupSubRoute,
  onEnter: onEnterIndexRoute,
  loaderDeps: ({ search }) => ({ couponCode: search.ssu_coupon }),
  loader: async ({ context, deps, preload }) => {
    const isCouponCodeOn = context.growthbook.isOn(
      'partners.acquisition.coupon-code',
    );

    if (!isCouponCodeOn) return;

    const couponEligibilityResponse = await context.queryClient.ensureQueryData(
      getCouponEligibilityQueryOptions(deps.couponCode),
    );

    if (!preload && couponEligibilityResponse?.status === 'not_found') {
      throw redirect({
        to: '.',
        search: (prev: Record<string, unknown>) => ({
          ...prev,
          ssu_coupon: undefined,
        }),
        replace: true,
      });
    }
  },
});
